import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Box from "@mui/material/Box";

import PlanForm from "./PlanForm";
import Title from "../../../common/Title";
import useAxios from "../../../../hooks/useAxios";
import useAlert from "../../../../hooks/useAlert";
import useAuth from "../../../../hooks/useAuth";
import { __fetchPlanDetails, __updatePlanDetails } from "../../../../api/plan";

const PlanUpdate = () => {
  const { user } = useAuth();
  const nav = useNavigate();
  const [initialData, setInitialData] = useState([]);
  const { setAlertMessage } = useAlert();
  const { plan_id } = useParams();
  const [response, call, apiLoading] = useAxios({
    ...__fetchPlanDetails(plan_id),
  });
  const [updateResponse, updateCall, updateApiLoading] = useAxios(
    __updatePlanDetails(plan_id)
  );

  if (!user.admin) {
    nav("/");
  }

  useEffect(() => {
    call();
  }, []);

  const handleFormSubmit = (data) => {
    updateCall({ data: data });
  };

  useEffect(() => {
    if (response && response.status) {
      setInitialData(response.data);
      return;
    }

    if (response && !response.status) {
      nav("/");
    }
  }, [response]);

  useEffect(() => {
    if (!updateResponse) return;
    if (updateResponse.status) {
      setAlertMessage({ type: "success", message: `Updated successfully.` });

      call();
    }
  }, [updateResponse]);

  if (apiLoading) {
    return <Title content="Please wait..." variant="subtitle2" gutterBottom />;
  }

  return (
    <Box
      sx={{ width: "100%" }}
      display="flex"
      alignItems="center"
      flexDirection="column"
    >
      <PlanForm
        isUpdate={true}
        initialValues={initialData}
        handleSubmit={handleFormSubmit}
        loading={apiLoading || updateApiLoading}
      />
    </Box>
  );
};

export default PlanUpdate;

